<template>
  <div
    v-if="!mobile"
    class="b-products-filters__label"
    :class="activeClass"
    @click="toggleOptions">
    <span class="b-products-filters__span">{{ filter.filterLabel }}</span>
    <i class="icon icon-chevron-down"></i>
  </div>
  <div
    v-if="showOptions && !mobile"
    ref="dropdown__options"
    class="b-products-filters__options">
    <label
      v-for="(option, index) in filter.filterOptions"
      :key="index"
      :for="option.id"
      :class="{ selected: selectedFilter === option.id }">
      <input
        :id="option.id"
        v-model="selectedFilter"
        type="radio"
        :value="option.id"
        :name="filter.filterLabel" />
      <img v-if="option.img" :src="option.img" alt="" />
      <template v-else>{{ option.label }}</template>
    </label>
  </div>
  <div
    v-if="mobile"
    class="b-products-filters__options--mob"
    :class="{ row: filter.id === '02' }">
    <label
      v-for="(option, index) in filter.filterOptions"
      :key="index"
      :for="option.id"
      :class="{ selected: selectedFilter === option.id }">
      <input
        :id="option.id"
        :ref="option.id"
        v-model="selectedFilter"
        type="radio"
        :value="option.id"
        :name="filter.filterLabel"
        @click="toggleSelected(option.id)" />
      <img v-if="option.img" :src="option.img" alt="" />
      <template v-else>{{ option.label }}</template>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    preSelectedFilters: {
      required: false,
      type: Array,
      default: null,
    },
    filter: {
      required: true,
      type: Object,
    },
    mobile: {
      required: false,
      type: Boolean,
    },
  },
  emits: ['on-change-filter'],
  data() {
    return {
      showOptions: false,
      selectedFilter: '',
    }
  },

  computed: {
    activeClass() {
      return this.showOptions ? 'active' : ''
    },
  },
  watch: {
    selectedFilter() {
      const returnItem = this.filter.filterOptions.find(
        (item) => item.id === this.selectedFilter
      )
      this.$emit('on-change-filter', this.filter.id, returnItem)
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.preSelectedFilters) {
        this.preSelectedFilters.find((item) => {
          if (item.id === this.filter.id) {
            this.selectedFilter = item.selectedFilterId
          }
        })
      }
    })
  },
  methods: {
    toggleSelected(id) {
      if (this.selectedFilter === id) {
        this.selectedFilter = ''
      } else {
        this.selectedFilter = id
      }
    },
    toggleOptions() {
      this.showOptions = !this.showOptions
    },
    closeOptions() {
      this.showOptions = false
    },
    clear() {
      this.selectedFilter = ''
    },
  },
}
</script>
